// import {ChartIQService} from "./ChartIQService";
// import {ChartIQStudyService} from "./ChartIQStudyService";
import {QuoteFeedService} from "./QuoteFeedService";
// import {ChartIQStockComparisonService} from "./comparison/ChartIQStockComparisonService";
// import {ChartIQDrawingService} from "./ChartIQDrawingService";

export default angular.module("tfApp.components.chartiq.services", [])
                      // .service(ChartIQService.id, ChartIQService)
                      // .service(ChartIQStudyService.id, ChartIQStudyService)
                      .service(QuoteFeedService.id, QuoteFeedService)
                      // .service(ChartIQStockComparisonService.id, ChartIQStockComparisonService)
                      // .service(ChartIQDrawingService.id, ChartIQDrawingService)
                      .name;
